export default function Description() {
  return (
    <>
      <div className=" h-full w-auto flex items-center justify-center">
        <p className=" flex justify-center mt-0 md:mt-12  items-center text-gray-300 text-base mx-6 md:mx-0  md:text-2xl text-center">
          Balul Bobocilor marchează momentul în care noua generație de studenți ETTI pășește pentru prima dată în
          lumina reflectoarelor. Este un eveniment simbolic, ce reunește studenți, cadre didactice și invitați, 
          păstrând una dintre cele mai iubite tradiții ale facultății.
          <br />
          <br />
          Tema de anul acesta, „Night of Fates”, vă invită într-un univers al supranaturalului,
          unde magia și misterul se îmbină într-o atmosferă ireală. Decorul, luminile și momentele
          artistice vor transforma seara într-o călătorie printr-un tărâm al destinelor interconectate.
          <br />
          <br /> Momentul central al serii este concursul Miss & Mister Boboc ETTI 2025, în cadrul căruia
          perechile de boboci vor impresiona prin eleganță, carismă și momente artistice inspirate din tema balului.
          Coregrafii captivante, scenete pline de imaginație și surprize pregătite cu pasiune vor cuceri publicul.

          <br />
          <br /> 
          Este o noapte în care emoțiile se intensifică, iar fiecare pas făcut pe scenă devine parte din începutul unei povești.
          <br />
          
        </p>
      </div>
    </>
  );
}
